import { Component, ChangeDetectionStrategy } from '@angular/core';

/**
 * Component for the introduction section of the Go overview steps.
 */
@Component({
    selector: 'app-go-overview-intro',
    imports: [],
    templateUrl: './go-overview-intro.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrls: ['../../go-overview.component.scss'],
})
export class GoOverviewIntroComponent {}
